/* ============================================================================
FILE: po-axis-stratification-experiences-texts-fr-en-es-20260202.js
MODE: TwinLang FR/EN/ES via localStorage + lexicon injection
API:  window.PoAxisStratificationExperiencesTextsFR_EN_ES_20260202
ROOT: .po-axis-section[data-po-axis]
ROLE:
  - Langue pilotée par localStorage :
      clé principale : po_lex_lang
      clé compat     : goody_gp_lang
    Langues autorisées : fr, en, es.
  - Ré-injecte le contenu trilingue (fallback + lexique si dispo) dans les slots.
  - Les boutons FR / EN / ES pilotent la langue du bloc ; les traductions extérieures restent bloquées.
  - Protection fine: encapsule occurrence par occurrence les termes canoniques en translate="no".
  - Ajoute une couche audio locale et générale sans toucher au moteur de langue,
    au lexique ni aux protections existantes.
  - Ajoute le slot CTA fin de page : data-po-slot="cta_translate".
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_AXIS_STRATIF_EXP_TEXTS_20260202__) return;
  window.__PO_AXIS_STRATIF_EXP_TEXTS_20260202__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis]";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g,"-");
    var primary = s.split("-")[0] || "";
    if (primary === "es" || primary === "pt") return "es";
    if (primary === "en") return "en";
    return "fr";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY) || "";
      if (!v) v = localStorage.getItem(STORAGE_KEY_COMPAT) || "";
      return v ? normLang(v) : "";
    }catch(e){
      return "";
    }
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(e){}
    try{
      if (document && document.documentElement) document.documentElement.setAttribute("lang", l);
    }catch(e){}
    return l;
  }

  function detectRawLang(){
    if (typeof window !== "undefined" && window.PO_SITE_LANG) return window.PO_SITE_LANG;

    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return dl;

    var nav = (typeof navigator !== "undefined") ? navigator : null;
    if (nav && nav.languages && nav.languages.length) return nav.languages[0] || "";
    if (nav && nav.language) return nav.language || "";

    return "fr";
  }

  function getBrowserLang(){
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    return normLang(detectRawLang());
  }

  function getLang(){
    var s = readStoredLang();
    if (s) return s;

    var b = getBrowserLang();
    if (b) return b;

    return "fr";
  }

  function setLang(lang){
    var l = normLang(lang);
    applyLangEverywhere(l);
    return l;
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * CIBLAGE STRICT
   * -------------------------------------------------------------------------- */

  function isTargetRoot(root){
    if (!root || !root.getAttribute) return false;
    var axis = clampStr(root.getAttribute("data-po-axis")).toLowerCase();
    var id = clampStr(root.getAttribute("data-po-lex-id")).toLowerCase();
    return (
      axis === "stratification_experiences" ||
      id === "stratification_experiences" ||
      id === "stratification-dexperiences" ||
      id === "stratification_d_experiences"
    );
  }

  function getTargetBlocks(){
    var nodes = document.querySelectorAll(ROOT_SEL);
    var out = [];
    for (var i=0;i<nodes.length;i++){
      if (isTargetRoot(nodes[i])) out.push(nodes[i]);
    }
    return out;
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}

    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}

    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    try{
      if (entry.defs && entry.defs[lang]) return clampStr(entry.defs[lang]);
    }catch(e){}
    try{
      var k = "definition_" + lang;
      if (entry[k]) return clampStr(entry[k]);
      if (entry.definition_fr) return clampStr(entry.definition_fr);
      if (entry.definition_oper_fr) return clampStr(entry.definition_oper_fr);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    try{
      var ku = "usage_" + lang;
      if (entry[ku]) return clampStr(entry[ku]);
    }catch(e){}
    try{
      var kop = "definition_oper_" + lang;
      if (entry[kop]) return clampStr(entry[kop]);
    }catch(e){}
    try{
      var kd = "definition_" + lang;
      if (entry[kd]) return clampStr(entry[kd]);
    }catch(e){}
    try{
      if (entry.usage_fr) return clampStr(entry.usage_fr);
      if (entry.definition_oper_fr) return clampStr(entry.definition_oper_fr);
      if (entry.definition_fr) return clampStr(entry.definition_fr);
    }catch(e){}
    try{
      if (entry.defs && entry.defs[lang]) return clampStr(entry.defs[lang]);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  function pickArraySmart(entry, lang, bases){
    if (!entry) return [];
    for (var i=0;i<bases.length;i++){
      var a = pickArray(entry, lang, bases[i]);
      if (a && a.length) return a;
    }
    for (var j=0;j<bases.length;j++){
      var kfr = bases[j] + "_fr";
      try{
        var vfr = entry[kfr];
        if (Array.isArray(vfr) && vfr.length) return vfr;
      }catch(e){}
    }
    return [];
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine (idempotente, occurrence par occurrence)
   * -------------------------------------------------------------------------- */

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function collectSeedTerms(){
    return [
      "Stratification d’expériences",
      "Stratification d'experiences",
      "Stratification of Experiences",
      "Estratificación de experiencias",
      "Système Posœnnoïal",
      "Posœnnoïsme",
      "Sujet pluriel",
      "RéZonans",
      "Péroptissimisme",
      "Aliœvolution",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Katûpirsia",
      "Goodÿ",
      "ADAGP"
    ];
  }

  var __PO_PROTECT_CACHE__ = { key:"", terms:[], re:null };

  function collectCanonicalTerms(){
    var terms = [];
    var seen = Object.create(null);

    var seed = collectSeedTerms();
    for (var i=0;i<seed.length;i++) uniqPush(terms, seed[i], seen);

    try{
      if (window.PO_LEXICON_MAP){
        for (var id in window.PO_LEXICON_MAP){
          if (!window.PO_LEXICON_MAP.hasOwnProperty(id)) continue;
          var e = window.PO_LEXICON_MAP[id];
          if (!e || !e.terms) continue;
          uniqPush(terms, e.terms.fr, seen);
          uniqPush(terms, e.terms.en, seen);
          uniqPush(terms, e.terms.es, seen);
        }
      }else if (Array.isArray(window.PO_LEXICON)){
        for (var j=0;j<window.PO_LEXICON.length;j++){
          var ee = window.PO_LEXICON[j];
          if (!ee || !ee.terms) continue;
          uniqPush(terms, ee.terms.fr, seen);
          uniqPush(terms, ee.terms.en, seen);
          uniqPush(terms, ee.terms.es, seen);
        }
      }
    }catch(e){}

    terms.sort(function(a,b){ return b.length - a.length; });
    return terms;
  }

  function buildProtectRegex(terms){
    var parts = [];
    for (var i=0;i<terms.length;i++) parts.push(escapeRegExp(terms[i]));
    if (!parts.length) return null;
    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }catch(e){ return null; }
  }

  function ensureProtectEngineReady(){
    var key = "";
    try{
      if (window.PO_LEXICON_MAP) key = "map";
      else if (Array.isArray(window.PO_LEXICON)) key = "arr:" + window.PO_LEXICON.length;
      else key = "none";
    }catch(e){
      key = "none";
    }

    if (__PO_PROTECT_CACHE__.key === key && __PO_PROTECT_CACHE__.re) return;

    var terms = collectCanonicalTerms();
    var re = buildProtectRegex(terms);

    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.terms = terms;
    __PO_PROTECT_CACHE__.re = re;
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;

    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
      if (cls.indexOf("po-lex-locknode") !== -1) return true;
    }
    if (el.getAttribute && el.getAttribute("data-po-protect") === "1") return true;
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.setAttribute("data-po-protect", "1");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      last = start + match.length;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));

    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;

    var NodeFilterRef = (typeof NodeFilter !== "undefined") ? NodeFilter : (window && window.NodeFilter ? window.NodeFilter : null);
    if (!NodeFilterRef) return String(html);

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilterRef.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilterRef.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilterRef.FILTER_REJECT;
            return NodeFilterRef.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){
      return String(html);
    }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);

    return tpl.innerHTML;
  }

  function lockSlotNode(root, slot){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    try{
      el.setAttribute("translate","no");
      el.setAttribute("data-po-protect","1");
      var cls = (el.className && typeof el.className === "string") ? el.className : "";
      if (cls.indexOf("notranslate") === -1) cls = (cls ? (cls + " ") : "") + "notranslate";
      if (cls.indexOf("po-lex-locknode") === -1) cls = (cls ? (cls + " ") : "") + "po-lex-locknode";
      el.className = cls;
    }catch(e){}
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:"", lang:"fr", voice:null };
  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){ var L = normLang(lang); return AUDIO_UI[L] || AUDIO_UI.fr; }
  function getAudioRoots(){ return getTargetBlocks(); }
  function getDetailBlocks(root){ return root ? Array.prototype.slice.call(root.querySelectorAll(".po-lex-details") || []) : []; }

  function getTextValue(el){
    if (!el) return "";
    var txt = "";
    try{ txt = el.textContent || el.innerText || ""; }catch(e){ txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn");
    for (var i=0;i<btns.length;i++) if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail){
    if (!detail) return "";
    var parts = [];
    var title = detail.querySelector(".po-lex-summary__title") || detail.querySelector(".po-lex-summary");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join(". ");
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];

    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = "";

    for (var i=0;i<pieces.length;i++){
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;

      var proposal = current ? (current + " " + piece) : piece;
      if (proposal.length > 220){
        if (current) out.push(current.trim());
        current = piece;
      }else{
        current = proposal;
      }
    }

    if (current) out.push(current.trim());
    return out;
  }

  function getVoices(){
    try{ return PO_AUDIO_SYNTH ? (PO_AUDIO_SYNTH.getVoices() || []) : []; }
    catch(e){ return []; }
  }

  function pickVoiceForLang(lang){
    var voices = getVoices();
    if (!voices.length) return null;

    var target = normLang(lang);
    var starts = (target === "fr") ? ["fr"] : (target === "en") ? ["en"] : ["es"];

    for (var i=0;i<voices.length;i++){
      var v = voices[i];
      var vl = clampStr(v.lang).toLowerCase();
      for (var j=0;j<starts.length;j++) if (vl.indexOf(starts[j]) === 0) return v;
    }
    return voices[0] || null;
  }

  function getSpeechLangCode(lang){
    var L = normLang(lang);
    if (L === "en") return "en-US";
    if (L === "es") return "es-ES";
    return "fr-FR";
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles-stratification-experiences")) return;
    var style = document.createElement("style");
    style.id = "po-axis-audio-styles-stratification-experiences";
    style.textContent = ".po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;}" +
      ".po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid currentColor;background:transparent;color:inherit;padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;line-height:1.2;transition:opacity .2s ease,transform .2s ease;}" +
      ".po-axis-audio-btn:hover{transform:translateY(-1px);}" +
      ".po-axis-audio-btn[aria-pressed='true']{font-weight:600;}" +
      ".po-axis-section[data-po-lex-id='stratification_experiences'] .po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;}" +
      "@media (max-width:640px){.po-axis-section[data-po-lex-id='stratification_experiences'] .po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("translate", "yes");
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");
        var generalBtn = createAudioButton("general");
        generalWrap.appendChild(generalBtn);
        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector(".po-lex-details");
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling); else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else panel.appendChild(generalWrap);
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='detail']");
      if (!btn){
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    var activeRoot = (PO_AUDIO_STATE.root === root);
    var activeKey = PO_AUDIO_STATE.activeKey;
    var btns = root.querySelectorAll(".po-axis-audio-btn");

    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = btn.getAttribute("data-po-audio-role") || "detail";
      var idx = parseInt(btn.getAttribute("data-po-audio-index"), 10);
      var key = (role === "general") ? "general" : ("detail:" + (isNaN(idx) ? -1 : idx));
      var isActive = activeRoot && activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending);
      btn.textContent = isActive ? ui.stop : (role === "general" ? ui.general : ui.block);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    }
  }

  function stopAudio(){
    try{ if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel(); }catch(e){}

    var roots = getAudioRoots();
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.voice = null;
    PO_AUDIO_STATE.lang = getLang();

    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], getLang());
  }

  function openDetailForPlayback(detail){
    if (!detail) return;
    try{ if (typeof detail.open !== "undefined") detail.open = true; }catch(e){}
    try{ detail.setAttribute("open", "open"); }catch(_e){}
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    if (role === "general"){
      units.push({ role: "general", index: -1 });
      for (var i=0;i<details.length;i++) units.push({ role: "detail", index: i });
      return units;
    }
    var start = (typeof index === "number" && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++) units.push({ role: "detail", index: j });
    return units;
  }

  function getTextForUnit(root, unit){
    if (!root || !unit) return "";
    if (unit.role === "general") return collectGeneralText(root);
    var details = getDetailBlocks(root);
    var detail = details[unit.index];
    if (!detail) return "";
    openDetailForPlayback(detail);
    return collectDetailText(detail);
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;

    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      playCurrentUnit(true);
      return;
    }

    var chunk = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!chunk){ speakNextChunk(); return; }

    var utter = new SpeechSynthesisUtterance(chunk);
    utter.lang = getSpeechLangCode(PO_AUDIO_STATE.lang);
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.rate = 1;
    utter.pitch = 1;

    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };

    try{ PO_AUDIO_SYNTH.speak(utter); }
    catch(e){ speakNextChunk(); }
  }

  function playCurrentUnit(fromNext){
    if (!PO_AUDIO_STATE.root) return;
    if (!fromNext && PO_AUDIO_STATE.unitPos < 0) PO_AUDIO_STATE.unitPos = 0;
    if (fromNext) PO_AUDIO_STATE.unitPos += 1;

    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    var text = getTextForUnit(PO_AUDIO_STATE.root, unit);
    var chunks = splitTextForSpeech(text);

    if (!chunks.length){
      playCurrentUnit(true);
      return;
    }

    PO_AUDIO_STATE.chunks = chunks;
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = (unit.role === "general") ? "general" : ("detail:" + unit.index);

    refreshAudioLabels(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang);
    speakNextChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio();

    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);

    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;

      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();

        var role = this.getAttribute("data-po-audio-role") || "detail";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);

        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){
          stopAudio();
          return;
        }

        startAudio(root, role, isNaN(index) ? -1 : index);
      });

      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function"){
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function(){
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * FALLBACK trilingue (texte fourni)
   * -------------------------------------------------------------------------- */

  var FALLBACK = {
    fr: {
      title: "Stratification d’expériences",
      kicker:
        "Extrait de <em>Katûpirsia</em><br />(Modalité opérative — Fondamenteurs)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel", "Nombre guide 25"],
      chip_urls: ["https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Stratification_d_experience_2_100x100.png?v=1746224000","https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Stratification_d_experience_modalite_2_100x100.png?v=1746223999","https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_25_100x100.png?v=1750643458"],
      def_short:
        "Empilement souple et évolutif des vécus : chaque strate mémorielle enrichit le système sans effacement des couches antérieures.",
      def_long:
        "La Stratification d’expériences fonctionne comme un empilement dynamique de couches mémorielles, perceptives et interprétatives. " +
        "Chaque nouvelle expérience complète les précédentes, non par addition plate, mais par interactions : des significations inédites naissent entre les strates.\n\n" +
        "Cette dynamique constitue une véritable alluvion cognitive : un dépôt vivant, en expansion continue, dans lequel puiser à foison. " +
        "Dans le Système Posœnnoïal, elle peut activer simultanément l’Aliœvolution (continuité évolutive), la RéZonans (vibration entre strates), " +
        "le Péroptissimisme (tensions fécondes) et l’Illusion (filtres perceptifs par couches), tout en dialoguant avec la Superposition de perspectives, " +
        "l’Instantané multiple et l’Addition synchrêtique.",
      h_features: "Schématisation",
      h_questions: "Repères d’activation",
      hint_fold: "déplier",
      example_title: "Ex.",
      example:
        "Dans une œuvre, laisser coexister plusieurs strates (mémoire, perception, relecture) sans effacer les anciennes : " +
        "faire émerger un sens nouveau par frottement entre couches plutôt que par remplacement.",
      features: [
        "Empilement dynamique : couches mémorielles, perceptives, interprétatives.",
        "Perméabilité : une strate traverse l’autre, sans dilution ; les couches restent réactivables.",
        "Non-effacement : pas de “mise à zéro” du vécu ; les anciennes strates demeurent actives.",
        "Alluvion cognitive : dépôt vivant, fécond, mobilisable selon les besoins de l’instant.",
        "Tension productive : les superpositions peuvent créer des frictions fertiles (sans rupture destructrice)."
      ],
      questions: [
        "Quelles strates sont actuellement actives (mémoire, sensation, interprétation) et comment dialoguent-elles ?",
        "Quelle couche ancienne demande à être réactivée plutôt qu’oubliée ou remplacée ?",
        "Où une superposition produit-elle une tension féconde, et comment l’orienter vers une forme ?",
        "Quelle part relève du filtre (Illusion) et quelle part relève d’une ressource vibratoire réutilisable ?"
      ],
      h_family: "Modèle d’interaction",
      family_1:
        "<p><strong>Piliers activés :</strong> RéZonans, Aliœvolution, Péroptissimisme, Illusion.</p>" +
        "<p><strong>Outils mobilisés :</strong> Superposition de perspectives, Instantané multiple, Addition synchrêtique.</p>",
      family_2:
        "<p><strong>Nombre-guide 25 :</strong> tension équilibrante entre partenariat/coopération (2) et liberté/changement (5). " +
        "Dans la Stratification d’expériences, le 25 soutient l’intégration des transformations successives sans perte de cohérence : " +
        "stabilité interne et mouvement se répondent en continu.</p>",
      h_wordbuild: "Palimpseste, couches, alluvion",
      word_blocks: [
        {
          head: "Stratification — image opérative",
          text:
            "Penser l’expérience comme un terrain de dépôts successifs : chaque couche conserve sa texture, mais modifie l’ensemble. " +
            "La stratification ne juxtapose pas : elle transforme le présent par profondeur."
        },
        {
          head: "Palimpseste — différence posœnnoïale",
          text:
            "Le palimpseste suggère l’effacement partiel. Ici, au contraire, les strates ne s’effacent pas : elles demeurent actives, " +
            "en tension productive, réinterprétables à chaque instant."
        },
        {
          head: "Herméneutique — écho",
          text:
            "Comme dans l’herméneutique, les lectures s’empilent; mais ici la simultanéité est centrale : les couches coexistent et interagissent " +
            "dans le présent de l’acte créatif ou réflexif."
        }
      ],
      word_notes: [
        "En méditation : revisiter des couches mémorielles sans les figer, et laisser une compréhension neuve émerger par interaction.",
        "En création : construire une profondeur narrative/visuelle par strates réactivables, plutôt que par “version finale” définitive.",
        "En réflexion : accepter la coexistence des paradigmes; choisir selon l’usage, sans annuler les couches antérieures."
      ],
      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Stratification d’expériences",
      kicker:
        "Excerpt from <em>Katûpirsia</em><br />(Operative modality — Founders)",
      h_def: "Operative definition",
      chips: ["Concept ideogram", "Functional ideogram", "Guide number 25"],
      chip_urls: ["https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Stratification_d_experience_2_100x100.png?v=1746224000","https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Stratification_d_experience_modalite_2_100x100.png?v=1746223999","https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_25_100x100.png?v=1750643458"],
      def_short:
        "A supple, evolving stacking of lived experience: each memory-layer enriches the system without erasing earlier layers.",
      def_long:
        "Stratification of Experiences operates as a dynamic stacking of memorial, perceptual and interpretive layers. " +
        "Each new experience completes the previous ones through interaction rather than flat addition: new meanings arise between layers.\n\n" +
        "This dynamic forms a cognitive alluvium: a living deposit in continuous expansion, from which one can draw abundantly. " +
        "Within the Posœnnoïal System, it may activate Aliœvolution (evolutionary continuity), RéZonans (vibration between layers), " +
        "Péroptissimisme (fertile tensions) and Illusion (layered perceptual filters), while dialoguing with Superposition de perspectives, " +
        "Instantané multiple and Addition synchrêtique.",
      h_features: "Functional sketch",
      h_questions: "Activation cues",
      hint_fold: "expand",
      example_title: "Ex.",
      example:
        "In an artwork, let multiple layers (memory, perception, re-reading) coexist without deleting the older ones: " +
        "allow new meaning to emerge through friction between layers rather than replacement.",
      features: [
        "Dynamic stacking: memorial, perceptual, interpretive layers.",
        "Permeability: one layer crosses another without dilution; layers remain reactivable.",
        "Non-erasure: no “reset” of lived experience; earlier layers stay active.",
        "Cognitive alluvium: a fertile living deposit, usable according to the moment’s needs.",
        "Productive tension: superpositions can generate fertile frictions (without destructive rupture)."
      ],
      questions: [
        "Which layers are active right now (memory, sensation, interpretation), and how do they interact?",
        "Which older layer needs to be reactivated rather than forgotten or replaced?",
        "Where does a superposition produce fertile tension, and how can it be oriented into form?",
        "What belongs to the filter (Illusion), and what belongs to a reusable vibratory resource?"
      ],
      h_family: "Interaction model",
      family_1:
        "<p><strong>Activated pillars:</strong> RéZonans, Aliœvolution, Péroptissimisme, Illusion.</p>" +
        "<p><strong>Mobilized tools:</strong> Superposition de perspectives, Instantané multiple, Addition synchrêtique.</p>",
      family_2:
        "<p><strong>Guide number 25:</strong> a balancing tension between partnership/cooperation (2) and freedom/change (5). " +
        "Here, 25 supports integrating successive transformations without losing coherence: stability and movement continuously answer each other.</p>",
      h_wordbuild: "Palimpsest, layers, alluvium",
      word_blocks: [
        {
          head: "Stratification — operative image",
          text:
            "Think of experience as a ground of successive deposits: each layer keeps its texture yet reshapes the whole. " +
            "Stratification does not merely place side by side: it transforms the present through depth."
        },
        {
          head: "Palimpsest — the posœnnoïal difference",
          text:
            "A palimpsest implies partial erasure. Here, layers are not erased: they remain active, in productive tension, " +
            "reinterpretable at any moment."
        },
        {
          head: "Hermeneutics — an echo",
          text:
            "As in hermeneutics, readings accumulate; but simultaneity is central here: layers coexist and interact in the present of creation or reflection."
        }
      ],
      word_notes: [
        "Meditation: revisit memory-layers without freezing them; let fresh understanding emerge through interaction.",
        "Creation: build narrative/visual depth through reactivable layers rather than a definitive “final version”.",
        "Reflection: accept coexistence of paradigms; choose by use, without cancelling earlier layers."
      ],
      cta_translate: "Suggest a translation of the concept"
    },

    es: {
      title: "Stratification d’expériences",
      kicker:
        "Extracto de <em>Katûpirsia</em><br />(Modalidad operativa — Fundadores)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional", "Número guía 25"],
      chip_urls: ["https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Stratification_d_experience_2_100x100.png?v=1746224000","https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Stratification_d_experience_modalite_2_100x100.png?v=1746223999","https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_25_100x100.png?v=1750643458"],
      def_short:
        "Apilamiento flexible y evolutivo de los vividos: cada estrato memorial enriquece el sistema sin borrar las capas anteriores.",
      def_long:
        "La Estratificación de experiencias funciona como un apilamiento dinámico de capas memoriales, perceptivas e interpretativas. " +
        "Cada nueva experiencia completa las anteriores por interacción, no por suma plana: nacen significados inéditos entre estratos.\n\n" +
        "Esta dinámica constituye una auténtica aluvión cognitiva: un depósito vivo en expansión continua, del que se puede extraer abundantemente. " +
        "En el Sistema Posœnnoïal, puede activar simultáneamente Aliœvolution (continuidad evolutiva), RéZonans (vibración entre capas), " +
        "Péroptissimisme (tensiones fecundas) e Illusion (filtros perceptivos por capas), en diálogo con Superposition de perspectives, " +
        "Instantané multiple y Addition synchrêtique.",
      h_features: "Esquema funcional",
      h_questions: "Señales de activación",
      hint_fold: "desplegar",
      example_title: "Ej.",
      example:
        "En una obra, permitir la coexistencia de varias capas (memoria, percepción, relectura) sin eliminar las antiguas: " +
        "hacer surgir un sentido nuevo por fricción entre capas, no por sustitución.",
      features: [
        "Apilamiento dinámico: capas memoriales, perceptivas e interpretativas.",
        "Permeabilidad: una capa atraviesa otra sin diluirse; las capas siguen siendo reactivables.",
        "No-borrado: no hay “reinicio” del vivido; las capas antiguas permanecen activas.",
        "Aluvión cognitiva: depósito vivo y fértil, utilizable según la necesidad del instante.",
        "Tensión productiva: las superposiciones pueden generar fricciones fecundas (sin ruptura destructiva)."
      ],
      questions: [
        "¿Qué capas están activas ahora (memoria, sensación, interpretación) y cómo dialogan?",
        "¿Qué capa antigua necesita reactivarse en lugar de olvidarse o reemplazarse?",
        "¿Dónde una superposición produce una tensión fecunda y cómo orientarla hacia una forma?",
        "¿Qué pertenece al filtro (Illusion) y qué pertenece a un recurso vibratorio reutilizable?"
      ],
      h_family: "Modelo de interacción",
      family_1:
        "<p><strong>Pilares activados:</strong> RéZonans, Aliœvolution, Péroptissimisme, Illusion.</p>" +
        "<p><strong>Herramientas movilizadas:</strong> Superposition de perspectives, Instantané multiple, Addition synchrêtique.</p>",
      family_2:
        "<p><strong>Número guía 25:</strong> tensión equilibrante entre cooperación/relación (2) y libertad/cambio (5). " +
        "Aquí, el 25 sostiene la integración de transformaciones sucesivas sin perder coherencia: estabilidad y movimiento se responden continuamente.</p>",
      h_wordbuild: "Palimpsesto, capas, aluvión",
      word_blocks: [
        {
          head: "Estratificación — imagen operativa",
          text:
            "Pensar la experiencia como un terreno de depósitos sucesivos: cada capa conserva su textura, pero modifica el conjunto. " +
            "La estratificación no yuxtapone: transforma el presente por profundidad."
        },
        {
          head: "Palimpsesto — diferencia posœnnoïal",
          text:
            "El palimpsesto implica borrado parcial. Aquí, las capas no se borran: permanecen activas, en tensión productiva, " +
            "reinterpretables en cualquier instante."
        },
        {
          head: "Hermenéutica — eco",
          text:
            "Como en la hermenéutica, las lecturas se acumulan; pero aquí la simultaneidad es central: las capas coexisten e interactúan en el presente del acto creativo o reflexivo."
        }
      ],
      word_notes: [
        "Meditación: explorar capas superpuestas sin fijarlas; dejar que una comprensión nueva emerja por interacción.",
        "Creación: construir profundidad narrativa/visual por capas reactivables, no por una “versión final” cerrada.",
        "Reflexión: aceptar la coexistencia de paradigmas; elegir según el uso, sin anular las capas anteriores."
      ],
      cta_translate: "Proponer une traduction du concepto"
    }
  };

  function fb(lang){ return FALLBACK[lang] || FALLBACK.fr; }

  /* --------------------------------------------------------------------------
   * Slots
   * -------------------------------------------------------------------------- */

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    el.innerHTML = protectHTML(clampStr(html));
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    try{
      el.setAttribute("src", clampStr(src));
      el.setAttribute("alt", clampStr(alt));
    }catch(e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='"+slot+"']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push("<li>" + protectHTML(clampStr(arr[i])) + "</li>");
    el.innerHTML = out.join("");
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='"+slot+"']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectHTML(clampStr(b.head || "")) + '</div>' +
          '<div class="po-axis-wb__t">' + protectHTML(clampStr(b.text || "")) + '</div>' +
        '</div>'
      );
    }
    host.innerHTML = out.join("");
  }

  function setPressed(root, lang){
    var btns = root.querySelectorAll(".po-langbtn[data-po-lang], .po-lex-btn[data-po-lang]");
    for (var i=0;i<btns.length;i++){
      var b = btns[i];
      var k = normLang(b.getAttribute("data-po-lang"));
      var on = (k === lang);
      b.setAttribute("aria-pressed", on ? "true" : "false");
      if (b.classList && b.classList.toggle) b.classList.toggle("is-active", !!on);
    }
  }

  function bindLangButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll(".po-langbtn[data-po-lang], .po-lex-btn[data-po-lang]");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poLangBound) continue;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        setLang(this.getAttribute("data-po-lang") || "fr");
      });
      btn.__poLangBound = true;
    }
  }

  /* --------------------------------------------------------------------------
   * Mapping lexique -> page
   * -------------------------------------------------------------------------- */

  function renderFromLexicon(root, lang){
    var id = root.getAttribute("data-po-lex-id") || "stratification_experiences";
    var eMain =
      getLexiconEntry(id) ||
      getLexiconEntry("stratification_experiences") ||
      getLexiconEntry("stratification_d_experiences");

    if (!eMain) return false;

    var F = fb(lang);

    var title = (pickTerm(eMain, "fr")) || FALLBACK.fr.title;
    setSlotText(root, "title", title);
    lockSlotNode(root, "title");

    var kicker = clampStr(pickAny(eMain, "kicker_" + lang, "")) || clampStr(pickAny(eMain, "kicker_fr", ""));
    setSlotHTML(root, "kicker", kicker || F.kicker);

    setSlotText(root, "h_def", F.h_def);
    setSlotText(root, "chip_1", F.chips[0]);
    setSlotText(root, "chip_2", F.chips[1]);
    setSlotText(root, "chip_3", F.chips[2]);

    setSlotImgSrc(root, "chip_1_img", F.chip_urls[0], F.chips[0]);
    setSlotImgSrc(root, "chip_2_img", F.chip_urls[1], F.chips[1]);
    setSlotImgSrc(root, "chip_3_img", F.chip_urls[2], F.chips[2]);
    setSlotImgSrc(root, "title_img", F.chip_urls[0], title);

    setSlotText(root, "h_features", F.h_features);
    setSlotText(root, "h_questions", F.h_questions);
    setSlotText(root, "hint_fold", F.hint_fold);
    setSlotText(root, "hint_fold2", F.hint_fold);

    setSlotText(root, "h_family", F.h_family);
    setSlotText(root, "h_wordbuild", F.h_wordbuild);
    setSlotText(root, "hint_fold3", F.hint_fold);
    setSlotText(root, "cta_translate", F.cta_translate);

    var defS = pickDefShort(eMain, lang) || pickDefShort(eMain, "fr") || F.def_short;
    var defL = pickDefLong(eMain, lang)  || pickDefLong(eMain, "fr")  || F.def_long;

    setSlotText(root, "def_short", defS);
    var defLongHTML = defL ? ("<p>" + clampStr(defL).replace(/\n+/g, "</p><p>") + "</p>") : "";
    setSlotHTML(root, "def_long", defLongHTML);

    var feats = pickArraySmart(eMain, lang, ["characteristics","features"]) || [];
    var ques  = pickArraySmart(eMain, lang, ["usage_questions","tests_usage"]) || [];

    renderListInto(root, "features", (feats && feats.length) ? feats : F.features);
    renderListInto(root, "questions", (ques && ques.length) ? ques : F.questions);

    var example = clampStr(pickAny(eMain, "example_" + lang, "")) || clampStr(pickAny(eMain, "example_fr", "")) || F.example;
    var exHTML = example ? ("<div><strong>"+F.example_title+"</strong> " + clampStr(example) + "</div>") : "";
    setSlotHTML(root, "example_box", exHTML);

    setSlotHTML(root, "family_1", F.family_1);
    setSlotHTML(root, "family_2", F.family_2);

    var blocks = [];
    var notes  = [];
    var kb = "word_construction_blocks_" + lang;
    var kn = "word_construction_notes_" + lang;

    try{ if (Array.isArray(eMain[kb])) blocks = eMain[kb]; }catch(e){}
    try{ if (Array.isArray(eMain[kn])) notes  = eMain[kn]; }catch(e){}
    if (!blocks.length){ try{ if (Array.isArray(eMain["word_construction_blocks_fr"])) blocks = eMain["word_construction_blocks_fr"]; }catch(e){} }
    if (!notes.length){ try{ if (Array.isArray(eMain["word_construction_notes_fr"])) notes = eMain["word_construction_notes_fr"]; }catch(e){} }
    if (!blocks.length) blocks = F.word_blocks;
    if (!notes.length)  notes  = F.word_notes;

    renderWordBlocks(root, "wordbuild_blocks", blocks);
    renderListInto(root, "wordbuild_notes", notes);

    return true;
  }

  function lexiconLooksReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
    }catch(e){}
    return false;
  }

  function applyLangEverywhere(lang){
    lang = normLang(lang);
    storeLang(lang);

    var blocks = getTargetBlocks();
    for (var i=0;i<blocks.length;i++){
      bindLangButtons(blocks[i]);
      setPressed(blocks[i], lang);

      var ok = renderFromLexicon(blocks[i], lang);
      if (!ok){
        var F = fb(lang);

        setSlotText(blocks[i], "title", F.title);
        lockSlotNode(blocks[i], "title");

        setSlotHTML(blocks[i], "kicker", F.kicker);
        setSlotText(blocks[i], "h_def", F.h_def);
        setSlotText(blocks[i], "chip_1", F.chips[0]);
        setSlotText(blocks[i], "chip_2", F.chips[1]);
        setSlotText(blocks[i], "chip_3", F.chips[2]);

        setSlotImgSrc(blocks[i], "chip_1_img", F.chip_urls[0], F.chips[0]);
        setSlotImgSrc(blocks[i], "chip_2_img", F.chip_urls[1], F.chips[1]);
        setSlotImgSrc(blocks[i], "chip_3_img", F.chip_urls[2], F.chips[2]);
        setSlotImgSrc(blocks[i], "title_img", F.chip_urls[0], F.title);

        setSlotText(blocks[i], "h_features", F.h_features);
        setSlotText(blocks[i], "h_questions", F.h_questions);
        setSlotText(blocks[i], "hint_fold", F.hint_fold);
        setSlotText(blocks[i], "hint_fold2", F.hint_fold);
        setSlotText(blocks[i], "h_family", F.h_family);
        setSlotText(blocks[i], "h_wordbuild", F.h_wordbuild);
        setSlotText(blocks[i], "hint_fold3", F.hint_fold);
        setSlotText(blocks[i], "cta_translate", F.cta_translate);

        setSlotText(blocks[i], "def_short", F.def_short);
        var defLongHTML = "<p>"+clampStr(F.def_long).replace(/\n+/g,"</p><p>")+"</p>";
        setSlotHTML(blocks[i], "def_long", defLongHTML);

        renderListInto(blocks[i], "features", F.features);
        renderListInto(blocks[i], "questions", F.questions);
        var exHTML = "<div><strong>"+F.example_title+"</strong> " + F.example + "</div>";
        setSlotHTML(blocks[i], "example_box", exHTML);
        setSlotHTML(blocks[i], "family_1", F.family_1);
        setSlotHTML(blocks[i], "family_2", F.family_2);
        renderWordBlocks(blocks[i], "wordbuild_blocks", F.word_blocks);
        renderListInto(blocks[i], "wordbuild_notes", F.word_notes);
      }
    }

    initAudioEverywhere(lang);
    notifyLocaleChanged();
  }

  function init(){
    applyLangEverywhere(getLang());

    if (!lexiconLooksReady()){
      var tries = 0;
      var timer = setInterval(function(){
        tries++;
        if (lexiconLooksReady()){
          clearInterval(timer);
          __PO_PROTECT_CACHE__.key = "";
          applyLangEverywhere(getLang());
        }
        if (tries > 80) clearInterval(timer);
      }, 100);
    }
  }

  window.addEventListener("po:lexicon-ready", function(){
    __PO_PROTECT_CACHE__.key = "";
    applyLangEverywhere(getLang());
  });

  function watchHtmlLang(){
    if (!document || !document.documentElement || !window.MutationObserver) return;

    var last = getBrowserLang();
    var mo = new MutationObserver(function(){
      var now = getBrowserLang();
      if (now !== last){
        last = now;
        if (!readStoredLang()) applyLangEverywhere(now);
      }
    });

    try{ mo.observe(document.documentElement, { attributes:true, attributeFilter:["lang"] }); }catch(e){}
  }

  function watchProtectedSlots(){
    if (!document || !document.body || !window.MutationObserver) return;

    var t = 0;
    function schedule(){
      clearTimeout(t);
      t = setTimeout(function(){ applyLangEverywhere(getLang()); }, 60);
    }

    var mo = new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){
        var m = muts[i];
        var n = m && m.target;
        if (!n) continue;

        if (n.nodeType === 1){
          if (n.getAttribute && n.getAttribute("data-po-protect") === "1"){ schedule(); return; }
          if (n.closest && n.closest("[data-po-protect='1']")){ schedule(); return; }
        } else if (n.nodeType === 3){
          var p = n.parentNode;
          if (p && p.getAttribute && p.getAttribute("data-po-protect") === "1"){ schedule(); return; }
          if (p && p.closest && p.closest("[data-po-protect='1']")){ schedule(); return; }
        }
      }
    });

    try{ mo.observe(document.body, { subtree:true, characterData:true, childList:true }); }catch(e){}
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", function(){
      init();
      watchHtmlLang();
      watchProtectedSlots();
    });
  } else {
    init();
    watchHtmlLang();
    watchProtectedSlots();
  }

  window.addEventListener("beforeunload", function(){ stopAudio(); });

  window.PoAxisStratificationExperiencesTextsFR_EN_ES_20260202 = {
    init: init,
    setLang: setLang,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };

})();
